import Panel from './Panel/index.vue';
import Texts from './Texts/index.vue';
import Chart from './Chart/index.vue';
import Share from './Share/index.vue';
import NewShare from './NewShare/index.vue';
import ProgressLevel from './ProgressLevel/index.vue';

const install = Vue => {
  Vue.component(Texts.name, Texts);
  Vue.component(Panel.name, Panel);
  Vue.component(Chart.name, Chart);
  Vue.component(Share.name, Share);
  Vue.component(NewShare.name, NewShare);
  Vue.component(ProgressLevel.name, ProgressLevel);
};

export default install;



// WEBPACK FOOTER //
// ./src/components/common.js